module.exports = __webpack_public_path__ + "img/beijing.020841b6.png";